import React from 'react';
import { Text } from 'components/atoms';

const PlaceholderEditor = () => (
  <Text>Formulário em desenvolvimento.</Text>
)
export default PlaceholderEditor;
